/**
 * 🔒 SICUREZZA: Logger sicuro per frontend React
 * 
 * Disabilita log di debug in produzione e offusca informazioni sensibili
 */

const isDevelopment = process.env.NODE_ENV !== 'production';
const isDebugEnabled = process.env.REACT_APP_DEBUG === 'true' || isDevelopment;

/**
 * Offusca informazioni sensibili nei log
 */
function sanitizeLog(data) {
  if (typeof data === 'string') {
    // Offusca token JWT
    data = data.replace(/Bearer\s+([A-Za-z0-9\-_]+\.){2}[A-Za-z0-9\-_]+/g, 'Bearer [REDACTED]');
    // Offusca token completi anche senza Bearer
    data = data.replace(/(eyJ[A-Za-z0-9\-_]+\.[A-Za-z0-9\-_]+\.[A-Za-z0-9\-_]+)/g, '[TOKEN_REDACTED]');
    // Offusca password nei log
    data = data.replace(/password["\s:=]+([^"}\s,]+)/gi, 'password: [REDACTED]');
  } else if (typeof data === 'object' && data !== null) {
    // Se è un oggetto, cerca di offuscare token/password
    const sanitized = { ...data };
    if (sanitized.token) {
      sanitized.token = '[REDACTED]';
    }
    if (sanitized.password) {
      sanitized.password = '[REDACTED]';
    }
    return sanitized;
  }
  return data;
}

/**
 * Logger sicuro - disabilita debug in produzione
 */
const logger = {
  /**
   * Log solo in development o se REACT_APP_DEBUG=true
   */
  debug: (...args) => {
    if (isDebugEnabled) {
      console.log(...args.map(sanitizeLog));
    }
  },

  /**
   * Log sempre (per informazioni importanti)
   */
  log: (...args) => {
    if (isDevelopment) {
      console.log(...args.map(sanitizeLog));
    }
  },

  /**
   * Log errori sempre
   */
  error: (...args) => {
    console.error(...args.map(sanitizeLog));
  },

  /**
   * Log warning sempre
   */
  warn: (...args) => {
    console.warn(...args.map(sanitizeLog));
  },

  /**
   * Log info sempre (ma sanitizzato)
   */
  info: (...args) => {
    if (isDevelopment) {
      console.log(...args.map(sanitizeLog));
    }
  },

  /**
   * Log di sicurezza - solo in development
   */
  security: (...args) => {
    if (isDevelopment) {
      console.log('🔒 [SECURITY DEBUG]', ...args.map(sanitizeLog));
    }
  }
};

export default logger;
